import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class UserLearningType extends RestApiModel {
  static getResourceEndpoint() {
    return '/user/learning-type';
  }

  static getOptions() {
    return api.get(this.getResourceEndpoint() + '/options');
  }

}

export default UserLearningType;
